import { Routes, Route, RouteObject } from 'react-router';
import { withLDProvider, useFlags } from 'launchdarkly-react-client-sdk';
import '@/index.css';
import { AuthProvider } from './routes/AuthContext';
import { MfaProvider } from './feature/authentication/MfaContext';
import { routes } from './routes/routes';
import { Toaster } from 'sonner';
import { MaintenancePage } from './feature/maintenance/MaintenancePage';

// render nested routes
const renderRoutes = (routes: RouteObject[]) =>
  routes.map(({ path, element, children }, idx) => (
    <Route key={path || idx} path={path} element={element}>
      {children && renderRoutes(children)}
    </Route>
  ));

function App() {
  const { maintenanceMode } = useFlags();

  if (maintenanceMode) {
    return <MaintenancePage />;
  }

  return (
    <AuthProvider>
      <MfaProvider>
        <Routes>{renderRoutes(routes)}</Routes>
        <Toaster richColors />
      </MfaProvider>
    </AuthProvider>
  );
}

export default withLDProvider({
  clientSideID: import.meta.env.VITE_LAUNCHDARKLY_CLIENT_ID,
  context: {
    kind: 'user',
    key: 'anonymous',
  },
})(App);
